import { Link } from "react-router-dom";
import Header from "./Header";
import { useEffect, useState, useContext } from "react";
import i18n from "../translate/i18n";
import { UserContext } from "../contexts/UserContext";

import { useTranslation } from "react-i18next";
const UnderMaintanence = () => {
  const { t } = useTranslation();
  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);
  return (
    <>
      <div className="page-head-none">
        <Header />
      </div>

      <div className="page-not-found">
        <div className="not-found-img-wrap">
          <img
            src={require("../assests/maintanence.webp")}
            alt="page-not-found"
            className="page-img-light"
          />
          <img
            src={require("../assests/maintanence-dark.webp")}
            alt="page-not-found"
            className="page-img-dark"
          />
        </div>
        <h3 className="not-found-title">{t("ThisPageIsUnderMaintenance")}</h3>
        <p className="not-found-content">
          {t("PleaseCheck")} <div className="page-inline">{t("BackSoon")}</div>
        </p>
        <Link to="/" className="not-found-btn">
          {t("GoBackHomePage")}
        </Link>
      </div>
    </>
  );
};

export default UnderMaintanence;
